// extracted by mini-css-extract-plugin
module.exports = {"podium_container":"Podium_podium_container___tHlk","place":"Podium_place__u7iD2","first":"Podium_first__JGboD","second":"Podium_second__i2gCp","third":"Podium_third__W8X_Q"};